<template>

    <div class="page-editor editor-wrapper" style="flex-direction: column;" v-loading="loading" v-if="!loadingError">
        <div style="height:80px;">
            <el-scrollbar class="control-bar-wrapper" height="100%">
                <leftControlBar @cancel="cancelFn" @edit="editFn" />

                <componentLibs />

                <controlBar :scale.sync="canvasConfig.scale" @import-psd-data="importPsdData"
                    @showPreview="showPreviewFn" @publish="publishFn" @save="saveFn" />
            </el-scrollbar>

        </div>
        <!--内容-->
        <div class="page-editor editor-wrapper" style="overflow: hidden;">
            <!--左侧导航-->
            <!-- <div class="editor-side-bar border-R">
      <el-tabs tab-position="left" v-model="activeSideBar" style="height: 100%">
        <el-tab-pane
          v-for="(item, index) in sidebarMenus"
          :key="index"
          :name="item.value"
        >
          <el-tooltip
            slot="label"
            class="item"
            effect="dark"
            :content="item.label"
            placement="right"
          >
            <i :class="item.elementUiIcon"></i>
          </el-tooltip>
        </el-tab-pane>
      </el-tabs>
    </div> -->
            <!--组件&页面&模板-->
            <div class="editor-page-edit-wrapper">
                <pageManage v-if="activeSideBar === 'pageManage'" />
            </div>
            <!--页面编辑区域-->
            <div class="editor-main" ref="editorMain">
                <editorPan :scale.sync="canvasConfig.scale" />
            </div>
            <!--属性编辑区域-->

            <div class="el-attr-edit-wrapper scrollbar-wrapper">

                <el-tabs v-model="activeAttr" stretch>
                    <el-tab-pane label="选中元素" name="选中元素">

                        <attrEdit></attrEdit>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="事件" name="事件">
          <eventEdit></eventEdit>
        </el-tab-pane> -->
                    <el-tab-pane label="元素动画" name="元素动画">
                        <animationEdit></animationEdit>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="JS脚本" name="脚本">
          <scriptEdit></scriptEdit>
        </el-tab-pane> -->
                    <el-tab-pane label="场景背景" name="场景背景">
                        <pageAttrEdit></pageAttrEdit>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>

        <!--预览-->
        <previewPage v-if="showPreview" :programId="id" @closePreview="showPreview = false"></previewPage>

        <newProgramDialog v-if="showProgramDialog" @finish="savePage" :isNew="false" :data="programInfo">
        </newProgramDialog>
    </div>
    <div v-else style="display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;">
        <div style="margin-bottom:20px;">{{ loadingError }}</div>
        <el-button type="warning" @click="initPageData">重试</el-button>
    </div>
</template>

<script>
import componentLibs from "./components/component-libs/Index";
import pageManage from "./components/page-manage";
import editorPan from "./components/editor-panel/Index";
// 属性编辑相关组件
import attrEdit from "./components/attr-configure/attr-edit";
import animationEdit from "./components/attr-configure/animation-edit";
// import eventEdit from "./components/attr-configure/event-edit";
import pageAttrEdit from "./components/attr-configure/page-attr-edit";
// import scriptEdit from "./components/attr-configure/script-edit";

import controlBar from "./components/control-bar";
import leftControlBar from "./components/left-control-bar";

import previewPage from "../home/components/preview";

import { mapState, mapGetters } from "vuex";
import html2canvas from "html2canvas";
import newProgramDialog from '@client/components/new-program-dialog'

export default {
    components: {
        componentLibs,
        pageManage,
        editorPan,
        attrEdit,
        animationEdit,
        // eventEdit,
        pageAttrEdit,
        // scriptEdit,
        controlBar,
        leftControlBar,
        previewPage,
        newProgramDialog
    },
    data() {
        return {
            showProgramDialog: false,
            id: "", // 当前页面id
            loading: false,
            loadingError: null,
            showPreview: false,
            activeAttr: "选中元素",
            activeSideBar: "pageManage",
            sidebarMenus: [
                // {
                // 	label: '组件列表',
                // 	value: 'componentLibs',
                // 	elementUiIcon: 'el-icon-s-operation'
                // },
                {
                    label: "页面管理",
                    value: "pageManage",
                    elementUiIcon: "el-icon-document",
                },

            ],
            canvasConfig: {
                scale: 1,
            },
            programInfo: null
        };
    },
    computed: {
        ...mapGetters([
            'isChanged'
        ]),
        ...mapState({
            projectData: (state) => state.editor.projectData,
            activePageUUID: (state) => state.editor.activePageUUID,
            activeElementUUID: (state) => state.editor.activeElementUUID,
        }),
        activePage() {
            return this.projectData.pages.find(page => page.uuid === this.activePageUUID)
        }
    },
    created() {
        this.$store.dispatch("setPrjectData");
        this.id = this.$route.query.id;
        this.initPageData();
    },
    methods: {
        savePage(result) {
            if (result) {
                this.programInfo.category_id = result.category_id;
                this.programInfo.program_json.title = result.program_json.title;
                this.projectData.title = result.program_json.title;

                this.$store.dispatch("remarkChanged")
            }
            
            
            this.showProgramDialog = false;
        },
        /**
         * 初始化页面数据
         */
        initPageData() {
            this.loading = true;
            this.loadingError = null;
            this.$API.getPageDetail({ id: this.id })
                .then((res) => {
                    this.loading = false;
                    if (res.code != 0 && res.code != 1000) {
                        this.loadingError = res.data.message;
                        return;
                    }

                    this.canvasConfig.scale = (this.$refs.editorMain.clientWidth - 100) / res.data.program_json.width;

                    this.programInfo = res.data;
                    this.$store.dispatch("setPrjectData", {
                        ...res.data.program_json,
                    });

                })
                .catch((error) => {
                    this.loading = false;
                    this.loadingError = '网络或服务器错误';
                });
        },
        /**
         * 保存
         */
        async saveFn() {
            let _this = this;
            // await this.screenshots()
            // 提交数据再预览
            this.$API.updatePage({ program_id: this.id, program_json: this.projectData, category_id: this.programInfo.category_id || null }).then((res) => {
                console.log(res)

                _this.$store.dispatch("clearHistoryCache")

                this.$message.success("保存成功");
                this.showPreview = false;
            });
        },
        /**
         * 保存
         */
        async publishFn() {

        },
        async showPreviewFn() {
            // await this.screenshots()
            // 提交数据再预览
            // this.$API.updatePage({program_json: this.projectData}).then(() => {
            // 	this.showPreview = true
            // })
            this.$API.updatePage({ program_id: this.id, program_json: this.projectData, category_id: this.programInfo.category_id || null }).then((res) => {
                console.log(res)
                this.$message.success("保存成功!");
                this.showPreview = true;
            });
        },
        editFn() {
            this.showProgramDialog = true;
        },
        /**
         * 退出
         */
        cancelFn() {
            if (!this.isChanged) {
                this.$router.push({ name: "Home" });
                return;
            }

            this.$confirm("是否保存修改？", "提示", {
                confirmButtonText: "保存并退出",
                cancelButtonText: "直接退出",
                type: "warning",
            })
                .then(() => {
                    this.$API.updatePage({ program_id: this.id, program_json: this.projectData, category_id: this.programInfo.category_id || null }).then((res) => {
                        this.$message.success("保存成功!");
                        this.$router.push({ name: "Home" });
                    });
                })
                .catch(() => {
                    this.$router.push({ name: "Home" });
                });
        },
        /**
         * 提供截屏作为项目主图
         */
        screenshots() {
            const el = document.querySelector("#canvas-panel");
            return new Promise((resolve, reject) => {
                html2canvas(el, {
                    proxy: `${this.$config.baseURL}/common/html2canvas/corsproxy`,
                }).then((canvas) => {
                    const dataUrl = canvas.toDataURL("image/jpeg", 0.6);
                    const blob = this.$mUtils.dataURItoBlob(dataUrl);
                    const file = new window.File([blob], +new Date() + ".png", {
                        type: "image/png",
                    });
                    let params = new FormData();
                    params.append("file", file);
                    this.$axios
                        .post("/common/uploadFile", params)
                        .then((res) => {
                            // 替换主图链接
                            this.projectData.coverImage = res.body;
                            resolve(res.body);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            });
        },
        /**
         *@param dataList
         */
        importPsdData(psdData) {
            let elementsList = psdData.elements;
            let psdWidth = psdData.document.width;
            let scalingRatio = this.projectData.width / psdWidth;
            elementsList.forEach((item) => {
                let { width, height, top, left, imageSrc, opacity, zIndex } = item;
                setTimeout(() => {
                    this.$store.dispatch("preAddElement", {
                        elName: "qk-image",
                        defaultStyle: {
                            width: width * scalingRatio,
                            height: height * scalingRatio,
                            top: top * scalingRatio,
                            left: left * scalingRatio,
                            zIndex: zIndex,
                            opacity,
                        },
                        needProps: {
                            imageSrc: imageSrc,
                        },
                    });
                }, 10);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-wrapper {
    display: flex;
    height: 100%;
    position: relative;
    background-color: #FFF;

    .editor-side-bar {
        width: 55px;
        min-width: 55px;
    }

    .editor-page-edit-wrapper {
        width: 210px;
        min-width: 210px;
        padding: 0 1px;
    }

    .editor-main {
        flex: 1;
        background: #f0f2f5;
        position: relative;
        width: calc(100% - 55px - 210px - 380px);
    }

    .el-attr-edit-wrapper {
        min-width: 380px;
        width: 380px;
        padding: 0;
    }
}

.control-bar-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: absolute;
    // top: -60px;
    left: 0;
    width: 100%;
    text-align: center;
    z-index: 1000;
    height: 100%;
    background: #fff;
    // box-shadow: 0 0 30px 0 rgba(0, 0, 0, .3);
    border-bottom: 1px solid #ccc;
}

::v-deep .control-bar-wrapper .el-scrollbar__wrap .el-scrollbar__view {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
}

::v-deep .control-bar-wrapper .el-scrollbar__wrap {
    width: 100%;
    overflow-y: hidden;
    height: 80px;
}
</style>
<style lang="scss">
.editor-side-bar {
    .el-tabs__item.is-active {
        background: rgba(37, 165, 137, 0.09);
    }
}

.el-attr-edit-wrapper {
    .el-tabs {
        height: 100%;
        padding-left: 16px;
        padding-right: 16px;
        padding-bottom: 10px;
    }

    .el-tabs__content {
        height: calc(100% - 55px);

        &>div {
            height: 100%;
        }

        .attr-edit-inner {
            padding-left: 16px;
            padding-right: 16px;
        }
    }
}
</style>
